import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'negative'
})
export class NegativeNumberPipe implements PipeTransform {
  transform(str: string): string {
    return str.replace(/\u200f/g, '');
  }
}
